import React from "react";
import { StandardModalHeader } from "@design-system/Modal/Modal";
import { HStack } from "@design-system/HStack/HStack";
import { VStack } from "@design-system/VStack/VStack";
import { Button } from "@design-system/Button/Button";
import styles from "./AccountingMigrationModal.module.scss";

interface MigrationComingSoonStepProps {
    entityName: string | null | undefined;
    onBack: () => void;
}

export const MigrationComingSoonStep: React.FC<
    MigrationComingSoonStepProps
> = ({ entityName, onBack }) => (
    <>
        <StandardModalHeader>
            <VStack gap={4}>
                {entityName && (
                    <span className={styles.stepLabel}>
                        Migrate {entityName}
                    </span>
                )}
                <div>Coming soon</div>
            </VStack>
        </StandardModalHeader>
        <VStack gap={24}>
            <VStack gap={16}>
                <div className={styles.description}>
                    Migration for this software is coming soon. We'll send you a
                    note the moment it's ready.
                </div>
                <div className={styles.description}>
                    Questions? Reach us anytime at{" "}
                    <a href="mailto:help@kick.co">help@kick.co</a>.
                </div>
            </VStack>
            <HStack gap={8} justify="end">
                <Button variant="primary" size="md" onClick={onBack}>
                    Back
                </Button>
            </HStack>
        </VStack>
    </>
);
